import base from "@/store/utils/api-route/base";

const daftarItemAPI = {
    listItem: `${base.masterData}item/list_item_outlet`,
}

export default daftarItemAPI